import React from 'react';
import Breadcrumb from '../../../breadcrumb';
const Crumb = (props) => {
    const { data } = props;
    const renderHtml = () => {
        if (!data || !data.length) {
            return null;
        }
        return (React.createElement(Breadcrumb, null, data.map((item) => {
            return (React.createElement(Breadcrumb.Item, { key: item.key },
                item.icon,
                React.createElement("span", null, item.text)));
        })));
    };
    return renderHtml();
};
export default Crumb;
